import PropTypes from 'prop-types';
import React, { Component } from 'react';

import noop from 'lodash/noop';
import Logger from '@sm360/logger-sentry';
import { ShowroomService, Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { UrlService, LocaleService, ConfigsService } from '@sm360/widget-commons-core-services';
import { LoaderFullScreen } from '@sm360/widget-commons-general';
import { Wizard } from '@sm360/widget-commons-forms';

import VehicleForm from 'trade-in/components/VehicleForm/VehicleForm.jsx';
import ConfirmationStep from 'trade-in/components/ConfirmationStep/ConfirmationStep.jsx';
import OfficialTradeInForm from 'trade-in/components/OfficialTradeInForm/OfficialTradeInForm.jsx';

import 'trade-in/components/OfficialTradeInWrapper/OfficialTradeInWrapper.scss';

class OfficialTradeInWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScreenLock: false,
            quote: props.quote,
            tradeInVehicle: props.tradeInVehicle,
            tradeInValues: {
                low: 0,
                high: 0,
                amount: 0,
            },
        };

        this.loadQuote = this.loadQuote.bind(this);
        this.toggleScreenLock = this.toggleScreenLock.bind(this);
        this.allStepCompleted = this.allStepCompleted.bind(this);
        this.updateQuoteRevision = this.updateQuoteRevision.bind(this);
        this.updateTradeInVehicle = this.updateTradeInVehicle.bind(this);

        this.logger = new Logger(this.constructor.displayName, ConfigsService.getLoggerContext());
    }

    componentDidMount() {
        this.loadQuote();
    }
    getSteps() {
        const steps = [];

        steps.push(({ goNextStep }) => (
            <VehicleForm
                lockScreen={this.toggleScreenLock}
                quote={this.state.quote}
                onFormSubmit={(data) => this.setState(data, goNextStep)}
                onTradeInVehicleUpdated={this.updateTradeInVehicle}
                useCBB={false}
                isOfficialTradeIn
                tradeInVehicle={this.state.tradeInVehicle}
                loadQuote={this.loadQuote}
                config={this.props.config}
            />
        ));

        steps.push(({ goNextStep }) => (
            <OfficialTradeInForm
                quote={this.state.quote}
                updateQuoteRevision={this.updateQuoteRevision}
                onFormCompletion={goNextStep}
                tradeInValues={this.state.tradeInValues}
                tradeInVehicle={this.state.tradeInVehicle}
                tradeInId={this.state.tradeInVehicle.id}
                leadId={this.state.leadId}
                loadQuote={this.loadQuote}
                config={this.props.config}
            />
        ));

        steps.push(() => (
            <ConfirmationStep
                isRenderedInModal={this.props.isRenderedInModal}
                onTradeInSuccess={() => this.props.onTradeInSuccess(this.state.quote)}
            />
        ));

        return steps;
    }
    updateQuoteRevision(updatedQuotes) {
        if (this.state.quote) {
            const updatedQuote = updatedQuotes.find((quote) => quote.id === this.state.quote.id);
            if (updatedQuote) {
                this.setState((prevState) => ({
                    quote: prevState.quote.set('revision', updatedQuote.__revision || updatedQuote.revision),
                }));
            }
        }
    }

    updateTradeInVehicle(tradeInVehicle, onStateSet) {
        this.setState((oldState) => {
            return { ...oldState, tradeInVehicle };
        }, onStateSet);
    }

    toggleScreenLock() {
        this.setState((prevState) => {
            return { isScreenLock: !prevState.isScreenLock };
        });
    }

    loadQuote() {
        const quoteId = UrlService.getUrlParameter('quoteId');
        const writeToken = UrlService.getUrlParameter('writeToken');
        if (quoteId) {
            ShowroomService.loadQuote(quoteId)
                .then((quote) => {
                    if (writeToken) {
                        this.setState({ quote: quote.set('securityToken', writeToken) });
                    } else {
                        this.setState({ quote });
                    }
                })
                .catch((error) => {
                    this.logger.error('OfficialTradeInWrapper#loadQuote error', error);
                });
        }
    }

    allStepCompleted() {
        return Object.values(this.state.completedSteps).every((step) => step);
    }

    render() {
        return (
            <div className="OfficialTradeIn__wrapper">
                <LoaderFullScreen show={this.state.isScreenLock} message={LocaleService.t('TRADE_IN.SCREEN_LOCKED')}>
                    <Wizard steps={this.getSteps()} />
                </LoaderFullScreen>
            </div>
        );
    }
}

OfficialTradeInWrapper.defaultProps = {
    quote: null,
    onTradeInSuccess: noop,
    config: {},
};

OfficialTradeInWrapper.propTypes = {
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    isRenderedInModal: PropTypes.bool.isRequired,
    onTradeInSuccess: PropTypes.func,
    config: PropTypes.object,
};

OfficialTradeInWrapper.displayName = 'OfficialTradeInWrapper';

export default OfficialTradeInWrapper;
